export enum ConnectorState {
  OPEN = 'open',
  CLOSED = 'closed',
  ERROR = 'error',
}

export enum ConnectorStateReason {
  EXPECTED = 'expected',
  UNEXPECTED = 'unexpected',
  UNAUTHORIZED = 'unauthorized',
}